var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.66 14.6501C10.68 13.9801 11.17 13.5201 11.86 13.5301C12.5 13.5401 13.03 14.0901 13.01 14.7201C12.99 15.3301 12.41 15.8801 11.79 15.8601C11.14 15.8501 10.64 15.3101 10.66 14.6501Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 13.53C15.53 13.51 15.01 14 15 14.67C15 15.32 15.49 15.85 16.14 15.87C16.76 15.89 17.33 15.34 17.34 14.71C17.35 14.07 16.84 13.54 16.18 13.53H16.19Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3401 14.69C19.3401 14.04 19.8501 13.53 20.5101 13.53C21.1701 13.53 21.6801 14.04 21.6801 14.69C21.6801 15.34 21.1501 15.87 20.5101 15.87C19.8801 15.87 19.3401 15.33 19.3401 14.69Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15.02C4 8.43 10.23 4.01 16.05 4.01V4C21.81 4 27.99 8.42 27.99 15.01C27.99 21.09 22.49 23.91 21.53 24.36L16.63 28.59C16.46 28.74 16.26 28.81 16.05 28.81C15.92 28.81 15.8 28.78 15.68 28.73C15.42 28.61 15.23 28.36 15.18 28.08C15.17 28.02 15.1 27.68 14.68 25.72C10.01 25.14 4 21.03 4 15.02ZM20.47 22.95C20.54 22.89 20.62 22.85 20.7 22.81H20.69L20.7073 22.8026C21.1092 22.6311 26.22 20.4504 26.22 15.02C26.22 9.49 20.91 5.78 16.05 5.78C11.19 5.78 5.76999 9.57 5.76999 15.02C5.76999 20.2 11.5 23.81 15.45 24.01C15.85 24.03 16.19 24.32 16.27 24.71C16.41 25.36 16.52 25.87 16.61 26.28L20.47 22.95Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.fb2ffb538fc3680ad626bac4eb67802b.svg";
export { ForwardRef as ReactComponent };